module.exports = __webpack_public_path__ + "img/help.1a13a27e.svg";